module.exports = __webpack_public_path__ + "img/resized-APP-0015-1.37e46cd3.png";